const it_IT = {
    homepage_title: 'Scarica CalendarTask mobile con QR code',
    homepage_slogn: 'CalendarTask versione mobile',
    homepage_ios_download: 'App Store in revisione...',
    homepage_download: 'Scarica',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Scarica CalendarTask mobile con QR code',
    phonedownload_slogan: 'Sincronizza con PC e tablet, annota ovunque',
    phonedownload_send_vip: 'Installa l\'app e ricevi abbonamento VIP',
    phonedownload_screenshot: 'Screenshot',
    phodedownload_macos: 'CalendarTask versione macOS',
    phodedownload_windows: 'CalendarTask versione Windows',
    phodedownload_otherbutton: 'Visualizza ora',
    phodedownload_about: 'Contattaci',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Senza pubblicità',
    feature_easy: 'Vista mensile, semplice e facile',
    feature_reminder: 'Promemoria personalizzato',
    feature_countdown: 'Conto alla rovescia anniversario',

    vip_task_succ: 'Successo. Scarica l\'app mobile per attivare VIP',
    vip_task_error: 'Ricezione fallita',

    group_slogn: 'Invito CalendarTask team',

    tt_title: 'CalendarTask',
    tt_share_1: 'Condiviso con te',
    tt_share_2: 'Orario',
    tt_share_show_1: 'Scansiona il QR code con l\'app "CalendarTask", PC e mobile mostreranno',
    tt_share_show_2: 'l\'orario',
    tt_share_scan_1: 'Scansiona con',
    tt_share_scan_2: 'app "CalendarTask"',
    tt_share_succ: 'Sincronizzazione riuscita',

    v2_copyright: 'Contatto service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Tutti i diritti riservati.',
    v2_download_appstore: 'Scarica su App Store',
    v2_download_googleplay: 'Disponibile su Google Play',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Cerca <span class="name">CalendarTask</span> su App Store o Google Play',
    v2_download_ios: 'Scarica iOS',
    v2_download_android: 'Scarica Android',
    v2_download_harmonyos: 'Scarica HarmonyOS',
    v2_sync_status: 'Sincronizzazione completata! 1 caricato, 0 scaricati',
    v2_feature_title: 'Sincronizzazione multi-dispositivo',
    v2_feature_description: 'Sincronizza tra telefono, tablet e PC'
};
export default it_IT;
